document.addEventListener('click', function (event) {
  var button = event.target.closest('.ss-lazy-vimeo__button');
  if (!button) return;
  var container = button.closest('.ss-lazy-vimeo');
  if (!container || container.dataset.loaded === 'true') return;
  container.dataset.loaded = 'true';
  var videoId = container.dataset.vimeoId;
  var iframe = document.createElement('iframe');
  iframe.src = 'https://player.vimeo.com/video/' + encodeURIComponent(videoId) + '?autoplay=1&title=0&byline=0&portrait=0';
  iframe.title = 'Sticks and Steel video';
  iframe.allow = 'autoplay; fullscreen; picture-in-picture';
  iframe.allowFullscreen = true;
  iframe.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
  container.replaceChildren(iframe);
});